export default __webpack_public_path__ + "static/media/Les_Tournesols_porte_cle_coeur.b5796be5.png";